function checksumFromArrayBuffer(buffer) {
  const view = new DataView(buffer);
  let checksum = 0;
  for (let i = 0; i < view.byteLength; i++) {
    checksum += view.getUint8(i);
  }
  return checksum;
}

module.exports = checksumFromArrayBuffer;